import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-main-outlet',
  templateUrl: './main-outlet.component.html',
  styleUrls: ['./main-outlet.component.scss'],
})
export class MainOutletComponent {}
